export type DevicePlatform = 'ios' | 'android' | 'desktop';

export interface DeviceInfo {
  platform: DevicePlatform;
  isIOS: boolean;
  isAndroid: boolean;
  isDesktop: boolean;
}

export const detectDevice = (): DeviceInfo => {
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

  const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream;
  const isAndroid = /android/i.test(userAgent);
  const isDesktop = !isIOS && !isAndroid;

  let platform: DevicePlatform = 'desktop';
  if (isIOS) platform = 'ios';
  else if (isAndroid) platform = 'android';

  return {
    platform,
    isIOS,
    isAndroid,
    isDesktop,
  };
};

export const getAppStoreUrl = (platform: DevicePlatform): string => {
  const appStoreUrls = {
    ios: 'https://apps.apple.com/nl/app/heitje/id6755081441',
    android: 'https://play.google.com/store/apps/details?id=com.yourapp',
    desktop: '',
  };

  return appStoreUrls[platform];
};
